import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import BankAccount from '../../entities/bankAccount';
import Transaction from '../../entities/transaction';
export function deleteBankAccount(bankAccount: BankAccount, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = bankAccount.id;}
const _work = workingSet();

findAll<Transaction>('transactions').filter(transactionTemp => transactionTemp.sourceType === 'B' && transactionTemp.source === bankAccount.id && transactionTemp.status !== 'D').forEach(transactionTemp => {
const _transaction = ((_work.get('transaction:' + transactionTemp.id) ?? transactionTemp) as Transaction).clone();

_transaction.status = 'U';
_transaction.addedOn = newHRTimestamp();
_transaction.addedBy = getCurrentUserId();
_transaction.importSource = targetImportSource;
_transaction.importId = mergeId;
_work.set('transaction:' + _transaction.id, _transaction);
store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
});
findAll<Transaction>('transactions').filter(transactionTemp => transactionTemp.targetType === 'B' && transactionTemp.target === bankAccount.id && transactionTemp.status !== 'D').forEach(transactionTemp => {
const _transaction = ((_work.get('transaction:' + transactionTemp.id) ?? transactionTemp) as Transaction).clone();

_transaction.status = 'U';
_transaction.addedOn = newHRTimestamp();
_transaction.addedBy = getCurrentUserId();
_transaction.importSource = targetImportSource;
_transaction.importId = mergeId;
_work.set('transaction:' + _transaction.id, _transaction);
store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
});


bankAccount.status = 'D';
bankAccount.addedOn = newHRTimestamp();
bankAccount.addedBy = getCurrentUserId();
bankAccount.importSource = targetImportSource;
bankAccount.importId = mergeId;
store.dispatch(Actions.BankAccountActions.removeBankAccountQueue(bankAccount));
}
export function replaceBankAccount(bankAccount: BankAccount, replaceWith: BankAccount, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = bankAccount.id;}
const _work = workingSet();

findAll<Transaction>('transactions').filter(transactionTemp => transactionTemp.sourceType === 'B' && transactionTemp.source === bankAccount.id && transactionTemp.status !== 'D').forEach(transactionTemp => {
const _transaction = ((_work.get('transaction:' + transactionTemp.id) ?? transactionTemp) as Transaction).clone();
_transaction.source = replaceWith.id;
_transaction.status = 'U';
_transaction.addedOn = newHRTimestamp();
_transaction.addedBy = getCurrentUserId();
_transaction.importSource = targetImportSource;
_transaction.importId = mergeId;
_work.set('transaction:' + _transaction.id, _transaction);
store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
});
findAll<Transaction>('transactions').filter(transactionTemp => transactionTemp.targetType === 'B' && transactionTemp.target === bankAccount.id && transactionTemp.status !== 'D').forEach(transactionTemp => {
const _transaction = ((_work.get('transaction:' + transactionTemp.id) ?? transactionTemp) as Transaction).clone();
_transaction.target = replaceWith.id;
_transaction.status = 'U';
_transaction.addedOn = newHRTimestamp();
_transaction.addedBy = getCurrentUserId();
_transaction.importSource = targetImportSource;
_transaction.importId = mergeId;
_work.set('transaction:' + _transaction.id, _transaction);
store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
});


return bankAccount;
}
export function deleteImpactBankAccount(bankAccount: BankAccount) {
const impacts: string[] = [];
const state = store.getState();

const transactionSourceTypeImpact = findAll<Transaction>('transactions').filter(transaction => transaction.sourceType === 'B' && transaction.source === bankAccount.id && transaction.status !== 'D');
transactionSourceTypeImpact.forEach(() => impacts.push('transactions'));
const transactionTargetTypeImpact = findAll<Transaction>('transactions').filter(transaction => transaction.targetType === 'B' && transaction.target === bankAccount.id && transaction.status !== 'D');
transactionTargetTypeImpact.forEach(() => impacts.push('transactions*'));


return util.countDistinct(impacts);
}
